import React from 'react';
import { v2BrandLogo } from '../../pages/SiteRefreshPreview/siteRefreshContent';

const PreviewFooter = ({ socialLinks }) => (
  <footer className="site-refresh__footer">
    <div className="site-refresh__shell">
      <div className="site-refresh__newsletter">
        <div className="site-refresh__newsletter-copy">
          <div className="site-refresh__eyebrow">Receba novidades</div>
          <p className="site-refresh__intro">
            Fique por dentro dos bastidores, lançamentos e cases da Napalm Studio.
          </p>
        </div>
        <form className="site-refresh__newsletter-form" onSubmit={(e) => e.preventDefault()}>
          <input
            type="email"
            placeholder="Seu melhor e-mail"
            className="site-refresh__newsletter-input"
            aria-label="E-mail"
          />
          <button type="submit" className="site-refresh__newsletter-submit" aria-label="Enviar">
            →
          </button>
        </form>
      </div>

      <div className="site-refresh__footer-bar">
        <div className="site-refresh__footer-brand">
          <img src={v2BrandLogo} alt="Napalm Studio" className="site-refresh__footer-logo" />
          
        </div>
        <p className="site-refresh__copyright">
          © 2024 Napalm Studio. Todos os direitos reservados.
        </p>
        <div className="site-refresh__socials">
          {socialLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="site-refresh__social-link"
              target="_blank"
              rel="noreferrer"
              aria-label={link.label}
            >
              <img
                className="site-refresh__social-icon"
                src={encodeURI(link.icon)}
                alt=""
                width={22}
                height={22}
                decoding="async"
              />
            </a>
          ))}
        </div>
      </div>
    </div>
  </footer>
);

export default PreviewFooter;
